import apiSlice from "./ApiSlice";
import { LanguageFormValues } from "src/models/Language.model";

export const languageApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET ALL
    getAllLanguages: builder.query({
      providesTags: ["language"],
      query: () => {
        return {
          url: "/language",
          method: "GET",
        };
      },
    }),

    // GET
    getLanguages: builder.query({
      providesTags: ["language"],
      query: (body) => {
        return {
          url: "/language",
          method: "POST",
          body,
        };
      },
    }),

    // GET SINGLE LANGUUAGE
    getLanguagesById: builder.query({
      providesTags: ["language"],
      query: (id) => {
        return {
          url: `/language/${id}`,
          method: "GET",
        };
      },
    }),

    // ADD
    addLanguage: builder.mutation({
      invalidatesTags: ["language"],
      query: (body: LanguageFormValues) => {
        return {
          url: "/language/add",
          method: "POST",
          body,
        };
      },
    }),

    // Edit
    EditLanguage: builder.mutation({
      invalidatesTags: ["language"],
      query: ({ id, body }) => {
        return {
          url: `/language/${id}`,
          method: "PUT",
          body,
        };
      },
    }),

    // DELETE
    deleteLanguage: builder.mutation({
      invalidatesTags: ["language"],
      query: (id) => {
        return {
          url: `/language/${id}`,
          method: "DELETE",
        };
      },
    }),
  }),
});

export const {
  useGetAllLanguagesQuery,
  useGetLanguagesQuery,
  useGetLanguagesByIdQuery,
  useAddLanguageMutation,
  useEditLanguageMutation,
  useDeleteLanguageMutation,
} = languageApi;
